// Данные рядов формы бейджа. Отдельно от компонентов: файл с компонентом
// не должен экспортировать ничего кроме компонентов (react-refresh/only-export-components).
import type { DesignBadge, DesignBadgeItem } from '@/types/blocks'
import { messagesNow } from '@/i18n'
import { messages } from './messages'

type LabelKey =
  'badgeFill' | 'badgeOutline' | 'badgeVolume' | 'iconNone' | 'iconLucide' | 'iconCustom'

/** Подпись — геттер: читает язык интерфейса в момент обращения. */
const labelOf = <T extends object>(base: T, key: LabelKey): T & { label: string } =>
  Object.defineProperty({ ...base }, 'label', {
    enumerable: true,
    get: () => messagesNow(messages)[key],
  }) as T & { label: string }

/** Варианты, которые студия умеет и РАЗРЕШАЕТ писать. `oval` сюда не входит
 *  намеренно — это легаси-значение бека, только на чтение. */
export type BadgeVariant = 'square' | 'contrast' | 'pastel'

/** «Овал» убран из дизайна — легаси-значение показываем как «пастель» (ref:619).
 *  Правило доменное, а не оформительское: им пользуются и канвас, и форма (для
 *  подсветки активной кнопки), поэтому живёт оно тут, а не в стилях превью. */
export const resolveBadgeVariant = (v: DesignBadge['badgeVariant']): BadgeVariant =>
  v === 'oval' ? 'pastel' : v

export interface BadgeVariantOption {
  /** Только не-легаси варианты: `oval` UI писать не должен — теперь этого не даёт тип. */
  value: BadgeVariant
  label: string
}

/** Подписи эталонной дизайн-системы. «Овал» из выбора убран — легаси-значение
 *  показываем как «Объём», ровно как рендер (`resolveBadgeVariant`). */
export const BADGE_VARIANT_OPTIONS: BadgeVariantOption[] = [
  labelOf({ value: 'square' as const }, 'badgeFill'),
  labelOf({ value: 'contrast' as const }, 'badgeOutline'),
  labelOf({ value: 'pastel' as const }, 'badgeVolume'),
]

export interface IconTabOption {
  type: DesignBadgeItem['iconType']
  label: string
  /** Ветка есть в типе, но бек её не поддерживает — вкладка-заглушка (реф так же). */
  soon?: boolean
}

export const ICON_TAB_OPTIONS: IconTabOption[] = [
  labelOf({ type: 'none' as const }, 'iconNone'),
  labelOf({ type: 'lucide' as const }, 'iconLucide'),
  labelOf({ type: 'custom' as const, soon: true }, 'iconCustom'),
]
